import { render, staticRenderFns } from "./TablesVoip.vue?vue&type=template&id=49718df5&scoped=true&"
import script from "./TablesVoip.vue?vue&type=script&lang=js&"
export * from "./TablesVoip.vue?vue&type=script&lang=js&"
import style0 from "./TablesVoip.vue?vue&type=style&index=0&id=49718df5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49718df5",
  null
  
)

export default component.exports